import { Navigate } from "react-router-dom";
import { useSignup } from "../context/signUpContext"; // Adjust the path as necessary

const StepProtectedRoute = ({ requiredStep, children }) => {
  const { completedSteps } = useSignup();
  
  if (!completedSteps[requiredStep]) {
    return <Navigate to="/personal-info" replace />;
  }
  
  return children;
};

export default StepProtectedRoute;
